import React from 'react';
import PropTypes from 'prop-types';
import {
  renderLabel,
  getLabelFromCopyOrFromTranslation,
} from '@tcp/core/src/utils/labels/labelUtilty.js';
import { getIconPath } from '@tcp/core/src/utils';
import { pdpSubLabels, PDP_SUB_LABELS } from '@tcp/core/src/utils/labels/browse/PDP.labels.js';
import withStyles from '../../../../../common/hoc/withStyles';
import storeSpecialPromotion from './StoreSpecialPromotion.style';

const StoreSpecialPromotion = ({
  className,
  isPickupSelectedAtProductDetail,
  handlePickupSelection,
  priceAfterDiscount,
  offerPrice,
  TCPPromotionPrice = '',
}) => {
  const ssBopisPromotionlabel = renderLabel(
    getLabelFromCopyOrFromTranslation(`${PDP_SUB_LABELS}.lbl_ss_bopis_promotion`, pdpSubLabels),
    'lbl_ss_bopis_promotion'
  );

  const ssSthBopisPromitionlabel = renderLabel(
    getLabelFromCopyOrFromTranslation(`${PDP_SUB_LABELS}.lbl_ss_sth_promotion`, pdpSubLabels),
    'lbl_ss_sth_promotion'
  );

  const handleKeyPress = (event, location) => {
    if (event.key === 'Enter' || event.key === ' ') {
      handlePickupSelection(location);
    }
  };

  const promotionInfo = isPickupSelectedAtProductDetail
    ? {
        icon: 'store-special-shipping',
        alt: 'shipping',
        label: ssSthBopisPromitionlabel,
        price: TCPPromotionPrice || offerPrice,
        location: 'home',
        class: 'shipping-icon',
      }
    : {
        icon: 'store-special-store',
        alt: 'pickup-store',
        label: ssBopisPromotionlabel,
        price: priceAfterDiscount,
        location: 'bopis',
        class: 'pickup-icon ',
      };

  return (
    <div
      className={`${className} pickup-price-promotion additional-class`} // Added 'additional-class'
      onClick={() => handlePickupSelection(promotionInfo.location)}
      onKeyPress={(event) => handleKeyPress(event, promotionInfo.location)}
      tabIndex={0}
      role="button"
      aria-label={`Select ${promotionInfo.label}`}
    >
      <img
        src={getIconPath(promotionInfo.icon)}
        alt={promotionInfo.alt}
        className={`${promotionInfo.class}`}
      />
      <span className="pickup-text">
        {promotionInfo.label}:{' '}
        <span className="discounted-price"> {`$${promotionInfo.price}`}</span>
      </span>
    </div>
  );
};

StoreSpecialPromotion.propTypes = {
  className: PropTypes.string,
  isPickupSelectedAtProductDetail: PropTypes.bool,
  handlePickupSelection: PropTypes.func.isRequired,
  priceAfterDiscount: PropTypes.number,
  offerPrice: PropTypes.number,
};

StoreSpecialPromotion.defaultProps = {
  className: '',
  isPickupSelectedAtProductDetail: false,
  priceAfterDiscount: 0,
  offerPrice: 0,
};

export default withStyles(StoreSpecialPromotion, storeSpecialPromotion);
